import createComponent, {
  ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const Container = createComponent<
  ElementWithProps<{ hasExpiredSoftPull: boolean }>
>('div', ({ hasExpiredSoftPull }) => ({
  className: cx('w-full', {
    'sm:rounded-md sm:bg-background-warning-subtle sm:p-xl': hasExpiredSoftPull
  })
}));

export const DetailText = createComponent('div', {
  className: 'flex flex-wrap items-center gap-x-sm text-text-default t-body-sm'
});

export const Separator = createComponent('div', {
  className: 'mx-xs size-xs rounded-full u:bg-text-strong'
});
